/*
 * Bisou Rivage — tour du site du 18/10 (version ALT). Va avec bisou-alt-tour.css.
 *   c. Formats et dimensions : chaque case du tableau reçoit le nom de sa colonne ; au téléphone, le CSS en
 *      fait une carte par format. Seulement les tableaux d'au moins quatre colonnes (celui des livraisons,
 *      à deux colonnes, reste un tableau). En « Avant », le CSS ne s'applique pas : le tableau d'origine revient.
 */
(function () {
  'use strict';
  try {
    document.querySelectorAll('.bisou-help__table').forEach(function (t) {
      var ths = t.querySelectorAll('thead th');
      if (ths.length < 4) return;
      var labels = Array.prototype.map.call(ths, function (th) { return th.textContent.replace(/\s+/g, ' ').trim(); });
      t.querySelectorAll('tbody tr').forEach(function (tr) {
        Array.prototype.forEach.call(tr.children, function (td, i) { if (labels[i]) td.setAttribute('data-bvfp-label', labels[i]); });
      });
      t.setAttribute('data-bvfp-cards', '');
      if (t.parentElement && t.parentElement.classList.contains('bisou-help__table-wrap')) t.parentElement.setAttribute('data-bvfp-cards', '');
    });
  } catch (e) { if (window.console) console.warn('[bvf-tour]', e); }
})();
